import React, { useContext, useEffect, useState } from 'react';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import SecondaryButton from "../../ui/SecondaryButton";
import TextBox from '../../ui/TextBox';
import IfmsDate from '../../ui/Date';
import { ApplicableTableSettings } from '../../tableSettings';
import { edi310BatchTable } from './tableSettings';
import SmartTable from '../../uiControls/SmartTable';
import { Edi310Header, EdiSharedInfo } from '../../fms.core/Edi310Header';
import { InvoiceListItem } from '../../fms.data/models/InvoiceListItem';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import moment from 'moment';
import numeral from 'numeral';
import { appendLine } from '../../util';
import ApplicationContext from '../../ApplicationContext';
import _ from 'lodash';
import CheckBox from '../../ui/CheckBox';
import { DateRenderer, FloatRenderer, TextAlignLeftRenderer } from '../../uiControls/SmartTableRenderers';
import { ApiResult } from '../../framework.core/data/ApiResult';
import { addDays, now } from '../../dateUtils';
import PrimaryButton from '../../ui/PrimaryButton';
import constants from '../../constants';

interface Edi310BatchStorageKeys {
  modelStorage: string,
};

interface Edi310BatchParams {
  selectedElement: InvoiceListItem,
  onPopupClose?: () => void,
};

interface Edi310BatchLoadedParams {
  edi310Batch: Edi310Header,
  setEdi310Batch: (x: Partial<Edi310Header>) => void,
  selectedElement: InvoiceListItem,
  onPopupClose?: () => void,
  clickEDI: () => void,
  searchEDI: () => void,
  run: boolean
};

function getStorageKeys(): Edi310BatchStorageKeys {
  return { modelStorage: 'common-edi-310-batch' }
}

function Edi310BatchImpl(params: Edi310BatchParams) {
  const { modelStorage } = getStorageKeys();
  const { selectedElement } = params;
  const [edi310Batch, setEdi310Batch, removeFromStorage] = useTypedFastStorage<Edi310Header>(modelStorage, null);

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [run, setRun] = useState(false);
  const appContext = useContext(ApplicationContext);

  useEffect(() => {
    initialize();
    return () => removeFromStorage()
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function loadExisting(): Promise<any> {
    var endDate = now();
    var startDate = addDays(endDate, -7).toString();
    const apiResult: ApiResult<Edi310Header> = await appContext.api.getEDI310Batch(selectedElement.id, startDate, endDate.toString());
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return;
    }

    return apiResult.result;
  }

  async function initialize() {
    const data = await loadExisting();
    if (data) {
      setEdi310Batch({ ...data });
    }

    var endDate = now().toString();
    var startDate = addDays(endDate, -7).toString();
    setEdi310Batch({ startDate: startDate, endDate: endDate })
  }

  if (!edi310Batch) {
    return null;
  }

  async function searchEDI() {
    const apiResult: ApiResult<Edi310Header> = await appContext.api.getEDI310Batch(selectedElement.id, edi310Batch?.startDate, edi310Batch?.endDate);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return;
    }

    if (apiResult.result) {
      setEdi310Batch({ ...apiResult.result });
    }
  }
  async function clickEDI() {
    setRun(true);
    if (edi310Batch?.ftpID === '' && edi310Batch.ftpPassword === '' && edi310Batch.ftpOutFolder === '' && edi310Batch.ftpScac === '') {
      await showGlobalOkDialog(<p>EDI Gateway is not setting.</p>);
      return;
    }

    var errMsg = await faCheckData();

    if (errMsg !== '') {
      await showGlobalOkDialog(<p>Please check following information. (Specify the missing entries.)<br />
        {errMsg}
      </p>);
      return;
    }

    var invoHdIds = '';
    edi310Batch?.lines.forEach(x => {
      if(x.selected)
        invoHdIds = invoHdIds.length === 0 ? x.invoiceId.toString() : (invoHdIds + ',' + x.invoiceId);
    });

    var receiverId = '';
    var receiverIdq = '';
    var senderId = '';
    var senderIdq = '';

    if (edi310Batch && edi310Batch.receiverID !== '' && edi310Batch.receiverID.indexOf(':') >= 0) {
      receiverId = edi310Batch.receiverID.substring(4);
      receiverIdq = edi310Batch.receiverID.substring(0, 2);
    }
    else {
      receiverId = edi310Batch?.receiverID ?? '';
      receiverIdq = 'ZZ';
    }

    if (edi310Batch && edi310Batch?.senderID !== '' && edi310Batch?.senderID.indexOf(':') >= 0) {
      senderId = edi310Batch.senderID.substring(4);
      senderIdq = edi310Batch.senderID.substring(0, 2);
    }
    else {
      senderId = edi310Batch?.senderID ?? '';
      senderIdq = 'ZZ';
    }

    const ediInfo = new EdiSharedInfo({
      receiverID: receiverId,
      receiverIdQualifier: receiverIdq,
      senderID: senderId,
      senderIdQualifier: senderIdq,
      fileName: `EDI${moment().format('yyyyMMdd')}${numeral(edi310Batch?.ediSeqNo).format('D8')}.TXT`
    });

    const apiResult = await appContext.api.make310(ediInfo, selectedElement.jobType,
      invoHdIds, 'c:\\temp', edi310Batch?.ftpScac, edi310Batch?.ediSeqNo);
    //const apiResult = await appContext.api.make310(jobtype:selectedElement.jobType, invoHdIds : invoHdIds,tempDir : '',ediInfo : ediInfo,ftpScac: edi310?.ftpScac, ediSeqNo : edi310?.ediSeqNo);
    if (apiResult && apiResult.success) {
      await showGlobalOkDialog(<p>Success !!!</p>);
      setRun(false);
      return;
    }
    else {
      var msg = apiResult?.result?.length !== 0 ? apiResult.result : 'Failed !!!';
      await showGlobalOkDialog(<p>{msg}</p>);
      setRun(false);
    }
  }

  async function faCheckData() {
    let errMsg = '';

    if (edi310Batch?.receiverID === '')
      errMsg = '* You must input Receiver';
    if (edi310Batch?.senderID === '')
      errMsg = appendLine(errMsg, '* You must input Sender');
    if(edi310Batch?.lines.filter(x => x.selected).length === 0)
      errMsg= appendLine(errMsg, '* You must select Invoice');
    return errMsg;
  }

  return (
    <Edi310BatchInitializedImpl
      edi310Batch={edi310Batch}
      setEdi310Batch={setEdi310Batch}
      selectedElement={selectedElement}
      searchEDI={searchEDI}
      clickEDI={clickEDI}
      onPopupClose={params.onPopupClose}
      run={run}
    />
  );
}

function SelectRenderer({ data, row }: any) {
  const toggleSelection = data[row.index].toggleSelection;
  const isView = data[row.index].isView;

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CheckBox value={data[row.index].selected} onChange={() => toggleSelection(row.index)} disabled={isView} />
    </div>
  );
}

function Edi310BatchInitializedImpl({
  edi310Batch,
  setEdi310Batch,
  selectedElement,
  onPopupClose,
  clickEDI,
  searchEDI,
  run
}: Edi310BatchLoadedParams) {
  const [selectedIndex, setSelectedIndex] = useState(0)

  function toggleSelection(i: number) {
    const _list = _.cloneDeep(edi310Batch.lines);
    _list[i].selected = !_list[i].selected;

    setEdi310Batch({ lines: _list })
  }

  const tableOptions: ApplicableTableSettings = {
    ...edi310BatchTable,
    selectable: true,
    rowProps: (row: any) => ({ onClick: () => setSelectedIndex(row.index) }),
    selectedRowIndex: selectedIndex,
    tableName: 'ediBatchTable',
    customTableId: 'ediBatchTable',
    data: edi310Batch.lines.map((x, i) => ({ ...x, i, toggleSelection })),
    rowRenderers: [
      { accessor: 'selected', Cell: SelectRenderer },
      { accessor: 'invoiceNo', Cell: TextAlignLeftRenderer },
      { accessor: 'invoiceDate', Cell: DateRenderer },
      { accessor: 'dueDate', Cell: DateRenderer },
      { accessor: 'ediDate', Cell: DateRenderer },
      { accessor: 'amount', Cell: FloatRenderer },
    ],
  };


  return (
    <div className='report-popup'>
      <div>
        <div style={{ width: '320px' }}>
          <InlineInputControlRow label="Invoice To" mode="smaller-2x">
            <TextBox value={edi310Batch.billToName} disabled />
          </InlineInputControlRow>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '310px' }}>
            <InlineInputControlRow label="Invoice Date" mode="smaller-2x">
              <div style={{ display: 'flex' }}>
                <div style={{ width: '80px' }}>
                  <IfmsDate value={edi310Batch.startDate ?? ''} onChange={(e) => { setEdi310Batch({ startDate: e ?? '' }) }} />
                </div>

                <div style={{ width: '25px', textAlign: 'center', marginLeft: '10px' }}>
                  ~
                </div>

                <div style={{ width: '80px' }}>
                  <IfmsDate value={edi310Batch.endDate ?? ''} onChange={(e) => { setEdi310Batch({ endDate: e ?? '' }) }}/>
                </div>
              </div>
            </InlineInputControlRow>
          </div>
          <div style={{ width: '100px', marginLeft : '20px' }}>
            <PrimaryButton name='e310Batch-search-button' focusable={true} style={{ height: '20px', paddingTop: '3px', fontSize: '11px', width: '60px' }} onClick={searchEDI}>Search</PrimaryButton>
          </div>
        </div>
        <div style={{ marginTop: '20px', width: '' }}>
          <SmartTable {...tableOptions} />
        </div>
      </div>

      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          disabled={run}
          onClick={clickEDI}>
          SEND TO EDI
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const Edi310Batch = ({
  onPopupClose,
  selectedElement
}: { onPopupClose?: () => void, selectedElement: InvoiceListItem }) => {
  return (
    <Edi310BatchImpl selectedElement={selectedElement} onPopupClose={onPopupClose} key={`edi310-details`} />
  );
};
export default Edi310Batch;
